<script>
export default {
  data () {
    return {
      imgShow: true,
      setting: {},

      interval: null,
      lastTs: 0,
      commandInterval: null
    }
  },
  watch: {
    '$store.state.highSpdMode' () {
      this.pollCommand()
    }
  },
  computed: {
    image () {
      return this.setting.link_type === 0 ? require('../../assets/direct324.jpg') : this.setting.link_type === 1 ? require('../../assets/indirect324.jpg') : this.setting.link_type === 2 ? require('../../assets/direct323.jpg') : this.setting.link_type === 3 ? require('../../assets/indirect323.jpg') : ''
    }
  },
  mounted () {
    this.updateData()
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.$api.getTs({
          collection: 'meter_setting_data',
          sn: this.$store.state.sn
        }).then((res) => {
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg)
          }
          if (res.data.data === null) {
            return
          }
          if (this.lastTs !== res.data.data.ts) {
            this.lastTs = res.data.data.ts
            this.updateData()
          }
        })
      }, 1000)
    }
    this.pollCommand()
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }

    this.pollStop()
    // 关闭快速模式
    if (this.commandInterval) {
      clearInterval(this.commandInterval)
      this.commandInterval = null
    }
    this.$store.commit('updateSpeedMode', '普通模式')
  },
  methods: {
    pollCommand () {
      if (this.$store.state.reqMode === 'udp' || this.$store.state.highSpdMode) {
        this.sendCommand()
        if (!this.commandInterval) {
          this.commandInterval = setInterval(() => {
            this.sendCommand()
          }, 600000)
        }
      } else {
        this.pollStop()
      }
    },
    pollStop () {
      if (this.commandInterval) {
        clearInterval(this.commandInterval)
        this.commandInterval = null
        console.log('关')
      }
    },
    sendCommand () {
      this.$api.command({
        sn: this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        lists: [[1, 6, 4]]
      }).then(res => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
        }
      })
    },
    async updateData () {
      var params = {
        'collection': 'meter_setting_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'fields': ['gtime_type', 'ct_direction', 'ct_ratio', 'pt_direction', 'pt_ratio', 'rct_ratio', 'link_type']
      }
      const {data: res} = await this.$api.queryLastData(params)
      if (res.code !== 0) {
        this.$message.error(res.msg)
      }
      if (res.data === null) {
        return
      }
      this.setting = res.data
    }
  }
}
</script>

<template>
  <div style="width: 80%; height: 100%; margin-left: 10%; display: flex; justify-content: center; align-items: center">
    <div style="height: 70%; width: 30%; background: #fff; font-size: 20px; padding: 0 20px; border-right: 1px solid black">
      <div style="font-size: 22px; margin-top: 20px; height: 30px">系统配置方式</div>
      <div style="font-size: 18px; margin-bottom: 20px;">请在电能质量分析仪本地配置</div>
      <div style="display: flex; height: calc((100% - 50px)/7); align-items: center; justify-content: space-around;">
        <div style="width: 50%">授时方式</div>
        <div style="width: 50%">
          <el-button style="width: 100px; height: 40px; font-size: 20px; color: #606266" disabled>{{
              setting.gtime_type === 0 ? '手动' : setting.gtime_type === 1 ? '4G(自动)' : setting.gtime_type === 2 ? '北斗/GPS(自动)' : ''
            }}
          </el-button>
        </div>
      </div>

      <div style="display: flex; height: calc((100% - 50px)/7); align-items: center; justify-content: space-around;">
        <div style="width: 50%">CT方向</div>
        <div style="width: 50%">
          <el-button style="width: 100px; height: 40px; font-size: 20px; color: #606266" disabled>
            {{ setting.ct_direction === 0 ? '正向' : setting.ct_direction === 1 ? '反向' : '' }}
          </el-button>
        </div>
      </div>
      <div style="display: flex; height: calc((100% - 50px)/7); align-items: center; justify-content: space-around;">
        <div style="width: 50%">CT变比</div>
        <div style="width: 50%">
          <el-button style="width: 100px; height: 40px; font-size: 20px; color: #606266" disabled>{{
              setting.ct_ratio
            }}
          </el-button>
        </div>
      </div>
      <div style="display: flex; height: calc((100% - 50px)/7); align-items: center; justify-content: space-around;">
        <div style="width: 50%">PT方向</div>
        <div style="width: 50%">
          <el-button style="width: 100px; height: 40px; font-size: 20px; color: #606266" disabled>
            {{ setting.pt_direction === 0 ? '正向' : setting.pt_direction === 1 ? '反向' : '' }}
          </el-button>
        </div>
      </div>
      <div style="display: flex; height: calc((100% - 50px)/7); align-items: center; justify-content: space-around;">
        <div style="width: 50%">PT变比</div>
        <div style="width: 50%">
          <el-button style="width: 100px; height: 40px; font-size: 20px; color: #606266" disabled>{{
              setting.pt_ratio
            }}
          </el-button>
        </div>
      </div>
      <div
        style="display: flex; height: calc((100% - 50px)/7); align-items: center; justify-content: space-around; width: 100%;">
        <div style="width: 50%">漏电流CT变比</div>
        <div style="width: 50%">
          <el-button style="width: 100px; height: 40px; font-size: 20px; color: #606266" disabled>{{
              setting.rct_ratio
            }}
          </el-button>
        </div>
      </div>
<!--      <div style="display: flex; height: calc((100% - 50px)/8); align-items: center; width: 100%;">-->
<!--        <div style="width: 50%">接线方式</div>-->
<!--        <div style="width: 50%">-->
<!--          <el-button style="width: 160px; height: 40px; font-size: 20px; color: #606266" disabled>{{-->
<!--              setting.link_type === 0 ? '四线制直接采样' : setting.link_type === 1 ? '四线制间接采样' : setting.link_type === 2 ? '三线制直接采样' : setting.link_type === 3 ? '三线制间接采样' : ''-->
<!--            }}-->
<!--          </el-button>-->
<!--        </div>-->
<!--      </div>-->
    </div>
<!--    <div style="height: 70%; width: 30%; display: flex; align-items: end;" v-if="imgShow">-->
<!--      <img style="width: 100%; height: 50%; border: 1px solid black; padding: 2px" :src="image"/>-->
<!--    </div>-->
    <div style="height: 70%; width: 30%; background: #fff; font-size: 20px; padding: 0 20px;">
      <div style="font-size: 22px; margin-top: 20px; height: 30px">接线示意图</div>
      <div style="margin-top: 20px;">{{ setting.link_type === 0 ? '四线制直接采样' : setting.link_type === 1 ? '四线制间接采样' : setting.link_type === 2 ? '三线制直接采样' : setting.link_type === 3 ? '三线制间接采样' : '' }}</div>
      <div style="height: 70%; width: 100%; margin-top: 20px; display: flex; align-items: end;" v-if="imgShow">
        <img style="width: 100%; height: 100%; border: 1px solid black; padding: 2px" :src="image"/>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Device/Device.vue